import { MenuFold } from "../../shared/icons";
import GlobalSearch from "../../shared/global-search";

const NavbarSearchSection = ({
  isDark,
  sidebar,
  navPosition,
  handleChangePosition,
}) => {
  return (
    <section
      className={`hidden sm:flex flex-1 min-w-0 items-center gap-2 sm:gap-4 lg:gap-6 xl:gap-10 transition-all duration-200 ease-in-out ${
        sidebar || navPosition === "top"
          ? "ms-[70px] sm:ms-[80px] lg:ms-[215px]"
          : "ms-[70px] sm:ms-[80px] lg:ms-[65px]"
      }`}
    >
      {navPosition === "right" ? (
        <div
          className={`${
            sidebar || navPosition === "top" ? "rotate-180 " : ""
          }sm:block hidden shrink-0 transition-transform duration-200 ease-in-out cursor-pointer`}
          onClick={handleChangePosition}
        >
          <MenuFold isDark={isDark} />
        </div>
      ) : (
        ""
      )}
      <GlobalSearch isDark={isDark} />
    </section>
  );
};

export default NavbarSearchSection;
